module.exports = __webpack_public_path__ + "static/img/home_bg.7d7e40c5.png";